import * as Yup from 'yup';
import { CheckoutFormValues } from '../../types/appointments';
import { testPhoneNumbervalue } from '../global/helper';

export const initFormValues: CheckoutFormValues = {
  customer: {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    customerId: '',
    dob: '',
  },
  employeeId: '',
  appointmentId: '',
  startDateTime: '',
  price: 0,
  tipAmt: 0,
  paymentMethod: '' as any,
  customOrderItems: [],
  includeBonus: false,
  isCashTaxed: true,
};

export const customerCheckoutSchema = Yup.object({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().nullable().optional(),
  email: Yup.string().email('Invalid email').nullable().optional(),
  phoneNumber: Yup.string()
    .test({
      test: testPhoneNumbervalue,
      message: 'Invalid phone number',
    })
    .required('Phone number is required'),
  dob: Yup.string().nullable().optional(),
  customerId: Yup.string(),
});

export const checkoutSchema = Yup.object().shape({
  customer: customerCheckoutSchema.required(),
  employeeId: Yup.string(),
  appointmentId: Yup.string(),
  price: Yup.number(),
  tipAmt: Yup.number(),
  paymentMethod: Yup.string().optional(),
  giftCardAmount: Yup.number().optional(),
});
